import gsap from "gsap";

/**
 * demo.js
 * https://tympanus.net/codrops/2019/01/31/custom-cursor-effects/
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2019, Codrops
 * http://www.codrops.com
 */

class Cursor {
  constructor() {
    this.initCursor();
    this.initHovers();
  }

  initCursor() {
    this.outerCursor = document.querySelector(".circle-cursor--outer");
    this.innerCursor = document.querySelector(".circle-cursor--inner");
    this.outerCursorBox = this.outerCursor.getBoundingClientRect();
    this.outerCursorSpeed = 0;
    this.target = null;
    this.targetZindex = 0;
    this.targetPosition = "static";

    this.clientX = -100;
    this.clientY = -100;
    this.showCursor = false;

    const unveilCursor = () => {
      gsap.set(this.innerCursor, {
        x: this.clientX,
        y: this.clientY,
      });
      gsap.set(this.outerCursor, {
        x: this.clientX - this.outerCursorBox.width / 2,
        y: this.clientY - this.outerCursorBox.height / 2,
      });
      setTimeout(() => {
        this.outerCursorSpeed = 0.2;
      }, 100);
      this.showCursor = true;
    };
    document.addEventListener("mousemove", unveilCursor);

    document.addEventListener("mousemove", (e) => {
      this.clientX = e.clientX;
      this.clientY = e.clientY;
    });

    const render = () => {
      gsap.set(this.innerCursor, {
        x: this.clientX,
        y: this.clientY,
      });
      if (!this.isStuck) {
        gsap.to(this.outerCursor, {
          x: this.clientX - this.outerCursorBox.width / 2,
          y: this.clientY - this.outerCursorBox.height / 2,
          duration: this.outerCursorSpeed,
        });
      }
      if (this.showCursor) {
        document.removeEventListener("mousemove", unveilCursor);
      }
      requestAnimationFrame(render);
    };
    requestAnimationFrame(render);
  }

  initHovers() {
    const handleMouseEnter = (e) => {
      this.isStuck = true;
      this.target = e.currentTarget;

      if (this.target.classList.contains("c-card")) {
        const button = this.target.querySelector(".c-card__img .c-button");
        let style = window.getComputedStyle(button);
        this.targetZindex = style.zIndex;
        this.targetPosition = style.position;
        // const box = this.target.getBoundingClientRect();
        if (this.targetPosition === "static") {
          gsap.to(button, {
            position: "relative",
            zIndex: 4,
          });
        } else {
          gsap.to(button, {
            zIndex: 4,
          });
        }
      } else {
        let style = window.getComputedStyle(this.target);
        this.targetZindex = style.zIndex;
        this.targetPosition = style.position;
        // const box = this.target.getBoundingClientRect();
        if (this.targetPosition === "static") {
          gsap.to(this.target, {
            position: "relative",
            zIndex: 4,
          });
        } else {
          gsap.to(this.target, {
            zIndex: 4,
          });
        }
      }
      if (
        this.target.classList.contains("c-button") ||
        this.target.closest(".c-social") ||
        this.target.closest(".f-medias__content") ||
        this.target.closest(".f-immersion__cta a") ||
        this.target.closest(".f-immersion__cta") ||
        this.target.closest(".menu-item") ||
        this.target.classList.contains("c-video")
      ) {
        gsap.to(this.innerCursor, {
          width: "0px",
          height: "0px",
        });
      } else {
        gsap.to(this.innerCursor, {
          zIndex: 0,
          width: "30px",
          height: "30px",
        });
      }

      this.outerCursorOriginals = {
        width: this.outerCursorBox.width,
        height: this.outerCursorBox.height,
      };
      gsap.to(this.outerCursor, {
        // x: box.left,
        // y: box.top,
        // width: box.width,
        // height: box.height,
        opacity: 0,
      });
    };

    const handleMouseLeave = () => {
      this.isStuck = false;

      if (this.target.classList.contains("c-card")) {
        const button = this.target.querySelector(".c-card__img .c-button");
        if (this.targetPosition === "static") {
          gsap.to(button, {
            position: this.targetPosition,
            zIndex: this.targetZindex,
          });
        } else {
          gsap.to(button, {
            zIndex: this.targetZindex,
          });
        }
      } else {
        if (this.targetPosition === "static") {
          gsap.to(this.target, {
            position: this.targetPosition,
            zIndex: this.targetZindex,
          });
        } else {
          gsap.to(this.target, {
            zIndex: this.targetZindex,
          });
        }
      }

      gsap.to(this.outerCursor, {
        // width: this.outerCursorOriginals.width,
        // height: this.outerCursorOriginals.height,
        opacity: 1,
        duration: 0.2,
      });
      gsap.to(this.innerCursor, {
        width: this.outerCursorOriginals.width,
        height: this.outerCursorOriginals.height,
        duration: 0.2,
      });
    };

    const linkItems = document.querySelectorAll(
      "a:not(.f-event__img):not(.c-card__img-ctn), button, input"
    );
    linkItems.forEach((item) => {
      item.addEventListener("mouseenter", handleMouseEnter);
      item.addEventListener("mouseleave", handleMouseLeave);
    });

    const linkItemsCard = document.querySelectorAll("div.c-button");
    linkItemsCard.forEach((item) => {
      item.addEventListener("mouseenter", handleMouseEnter);
      item.addEventListener("mouseleave", handleMouseLeave);
    });

    const medias = document.querySelectorAll(".f-medias__content > div");
    if (medias.length > 0) {
      medias.forEach((item) => {
        item.addEventListener("mouseenter", handleMouseEnter);
        item.addEventListener("mouseleave", handleMouseLeave);
      });
    }

    // const videos = document.querySelectorAll('.c-video');
    // if(videos.length > 0){
    //     videos.forEach(item => {
    //         item.addEventListener("mouseenter", handleMouseEnter);
    //         item.addEventListener("mouseleave", handleMouseLeave);
    //     })
    // }

    const cLang = document.querySelector(".c-languages");
    if (cLang) {
      cLang.addEventListener("mouseenter", handleMouseEnter);
      cLang.addEventListener("mouseleave", handleMouseLeave);
    }
  }
}

export default Cursor;
